import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { authService } from '../services/api';
import '../styles/Login.css';

const OTPSetup = () => {
  const [qrCode, setQrCode] = useState(null);
  const [secret, setSecret] = useState('');
  const [username, setUsername] = useState('');
  const [otpCode, setOtpCode] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [tempToken, setTempToken] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    // Verificar se tem tempToken no localStorage
    const storedTempToken = localStorage.getItem('tempToken');
    const storedUsername = localStorage.getItem('tempUsername');
    
    if (!storedTempToken || !storedUsername) {
      setError('Sessão expirada. Faça login novamente.');
      setTimeout(() => {
        navigate('/login');
      }, 2000);
      return;
    }

    setTempToken(storedTempToken);
    setUsername(storedUsername);

    // Carregar QR Code
    loadQRCode(storedTempToken);
  }, [navigate]);

  const loadQRCode = async (token) => {
    try {
      setLoading(true);
      const response = await authService.setupOTP(token);
      setQrCode(response.qrCode);
      setSecret(response.secret);
    } catch (error) {
      console.error('Erro ao carregar QR Code:', error);
      setError(error.response?.data?.error || 'Erro ao carregar QR Code');
    } finally {
      setLoading(false);
    }
  };

  const handleVerify = async (e) => {
    e.preventDefault();
    setError('');

    if (!otpCode || otpCode.length !== 6) {
      setError('Digite um código de 6 dígitos');
      return;
    }

    try {
      setLoading(true);
      const response = await authService.enableOtp(tempToken, otpCode);
      
      // Limpar tokens temporários
      localStorage.removeItem('tempToken');
      localStorage.removeItem('tempUsername');

      // Salvar token e usuário
      localStorage.setItem('token', response.token);
      localStorage.setItem('user', JSON.stringify(response.user));

      // Redirecionar para popup de segurança
      navigate('/login/success', { 
        state: { 
          showSecurityPopup: true,
          user: response.user 
        } 
      });
    } catch (error) {
      console.error('Erro ao verificar OTP:', error);
      setError(error.response?.data?.error || 'Código inválido. Tente novamente.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-box">
        <div className="login-header">
          <h1>🔐 Configurar Autenticação em Dois Fatores</h1>
          <p>DVStelecom CRM</p>
        </div>

        <div className="otp-setup-content">
          <div className="otp-instructions">
            <h3>📱 Siga as instruções abaixo:</h3>
            <ol>
              <li>Instale o <strong>Google Authenticator</strong> (Android/iOS)</li>
              <li>Abra o app e toque em <strong>+</strong></li>
              <li>Escaneie o QR Code abaixo</li>
              <li>Digite o código de 6 dígitos exibido no app</li>
            </ol>
          </div>

          {loading && !qrCode ? (
            <div className="loading">Carregando QR Code...</div>
          ) : qrCode ? (
            <div className="qr-code-container">
              <img src={qrCode} alt="QR Code para Google Authenticator" />
              <p className="qr-hint">Escaneie com Google Authenticator</p>
              <p className="secret-hint">
                <small>Chave secreta: <code>{secret}</code></small>
              </p>
            </div>
          ) : null}

          <form onSubmit={handleVerify} className="login-form">
            <div className="form-group">
              <label htmlFor="otpCode">Código de Verificação</label>
              <input
                id="otpCode"
                type="text"
                inputMode="numeric"
                pattern="[0-9]*"
                maxLength="6"
                value={otpCode}
                onChange={(e) => setOtpCode(e.target.value.replace(/\D/g, ''))}
                placeholder="000000"
                disabled={loading}
                autoFocus
                className="otp-input"
              />
              <small>Código de 6 dígitos do Google Authenticator</small>
            </div>

            {error && (
              <div className="error-message">
                ⚠️ {error}
              </div>
            )}

            <button 
              type="submit" 
              className="btn-login"
              disabled={loading || !otpCode}
            >
              {loading ? 'Verificando...' : '✅ Ativar Autenticação'}
            </button>
          </form>
        </div>

        <div className="login-footer">
          <p>© 2026 DVStelecom. Todos os direitos reservados.</p>
        </div>
      </div>
    </div>
  );
};

export default OTPSetup;
